import React, { useState, useEffect } from "react";
import { config } from "../config/config";

const ResultadoActividadForm = ({ onSubmit, initialData, resetForm }) => {
    // Estado para almacenar los datos del formulario
    const [formData, setFormData] = useState({
        actividad_id: "",
        alumno_id: "",
        calificacion: "",
    });

    // Estados para almacenar las listas de actividades y alumnos
    const [actividades, setActividades] = useState([]);
    const [alumnos, setAlumnos] = useState([]);

    // Obtener actividades y alumnos desde la API
    useEffect(() => {
        // Obtener actividades
        fetch(`${config.apiUrl}/actividades`)
            .then((res) => res.json())
            .then(setActividades)
            .catch(console.error);

        // Obtener alumnos
        fetch(`${config.apiUrl}/alumnos/asignaciones`)
            .then((res) => res.json())
            .then(setAlumnos)
            .catch(console.error);
    }, []);

    // Efecto para cargar datos iniciales o resetear el formulario
    useEffect(() => {
        if (initialData) {
            setFormData(initialData);
        } else if (resetForm) {
            setFormData({
                actividad_id: "",
                alumno_id: "",
                calificacion: "",
            });
        }
    }, [initialData, resetForm]);

    // Manejar cambios en los campos del formulario
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Manejar el envío del formulario
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <div className="container mt-5">
            <h2 className="mb-4">Formulario de Resultado de Actividad</h2>
            <form onSubmit={handleSubmit} className="p-3 border rounded bg-light">
                <div className="row">
                    <div className="col-md-4 mb-3">
                        <label htmlFor="actividad_id" className="form-label">Actividad:</label>
                        <select
                            id="actividad_id"
                            name="actividad_id"
                            className="form-control"
                            value={formData.actividad_id}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Seleccione una actividad</option>
                            {actividades.map((actividad) => (
                                <option key={actividad.actividad_id} value={actividad.actividad_id}>
                                    {actividad.nombre_actividad} ({actividad.fecha})
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-4 mb-3">
                        <label htmlFor="alumno_id" className="form-label">Alumno:</label>
                        <select
                            id="alumno_id"
                            name="alumno_id"
                            className="form-control"
                            value={formData.alumno_id}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Seleccione un alumno</option>
                            {alumnos.map((alumno) => (
                                <option key={alumno.alumno_id} value={alumno.alumno_id}>
                                    {alumno.alumno_nombre}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-4 mb-3">
                        <label htmlFor="calificacion" className="form-label">Calificación:</label>
                        <input
                            type="number"
                            id="calificacion"
                            name="calificacion"
                            className="form-control"
                            step="0.01"
                            value={formData.calificacion}
                            onChange={handleChange}
                            required
                        />
                    </div>
                </div>
                <div className="text-center">
                    <button type="submit" className="btn btn-primary">Guardar</button>
                </div>
            </form>
        </div>);
};

export default ResultadoActividadForm;